import instance from "@/plugins/axios";
import { ResponseResult } from "@/core/models/response-result";
import {
  AbstractEventTypeRemoteDataSource,
  createEvenTypeParams,
} from "@/modules/eventType/remote/AbstractEventTypeRemoteDataSource";
import { DefaultEventType } from "@/modules/eventType/models/default-event-type";
import { DefaultResource } from "../models/default-resource";

export class EventTypeRemoteDataSource
  implements AbstractEventTypeRemoteDataSource
{
  async getEventTypes(): Promise<ResponseResult> {
    try {
      const response = (
        await instance.get<ResponseResult<any>>("Administration/event-types")
      ).data;

      if (!response.isSuccess) return response;

      response.data = this.convertFromJsonToDefaultEventTypeList(response.data);
      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  async createEvenType(
    eventType: string,
    params: createEvenTypeParams,
  ): Promise<ResponseResult> {
    try {
      const response = (
        await instance.put<ResponseResult<any>>(
          "Administration/event-types/" + eventType,
          params,
        )
      ).data;

      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  convertFromJsonToDefaultEventTypeList(data: any[]): DefaultEventType[] {
    return data.map((item) => this.convertFromJsonToDefaultEventType(item));
  }

  convertFromJsonToDefaultEventType(data: any): DefaultEventType {
    return {
      eventType: data.eventType,
      typicalDurationDays: data.typicalDurationDays,
      defaultResources: this.convertFromJsonToDefaultResourceList(
        data.defaultResources,
      ),
    };
  }

  convertFromJsonToDefaultResourceList(data: any[]): DefaultResource[] {
    return data.map((item) => this.convertFromJsonToDefaultResource(item));
  }

  convertFromJsonToDefaultResource(data: any): DefaultResource {
    return {
      id: data.id,
      resourceType: data.resourceType,
      resourceSubType: data.resourceSubType,
      defaultQuantity: data.defaultQuantity,
      required: data.required,
      displayOrder: data.displayOrder,
    };
  }
}
